<template>
  <div class="login-page">
    <div class="login-container">
      <div class="platform-name">服务商管理后台</div>
      <el-card class="login-card" shadow="never">
        <div class="login-title">登录</div>

        <!-- 登录方式切换 Tab -->
        <div class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: loginType === 'account' }"
            @click="switchTab('account')"
          >
            账号密码登录
          </div>
          <div
            class="tab-item"
            :class="{ active: loginType === 'phone' }"
            @click="switchTab('phone')"
          >
            手机号登录
          </div>
        </div>

        <!-- ========== 账号密码登录 ========== -->
        <el-form
          v-if="loginType === 'account'"
          :model="loginForm"
          :rules="rules"
          ref="loginForm"
          label-position="left"
          label-width="0"
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="用户名"
              size="large"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="loginForm.password"
              placeholder="密码"
              size="large"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item prop="vailCode">
                <i class="iconfont icon-yanzhengma icon"></i>
                <el-input
                  v-model="loginForm.vailCode"
                  placeholder="请输入验证码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <img :src="codeUrl" class="login-code" @click="refreshCode" />
            </el-col>
          </el-row>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleLogin"
              :loading="loading"
              style="width: 100%"
              size="large"
              >登录</el-button
            >
          </el-form-item>
        </el-form>

        <!-- ========== 手机号登录 ========== -->
        <el-form
          v-if="loginType === 'phone'"
          :model="phoneForm"
          :rules="phoneRules"
          ref="phoneForm"
          label-position="left"
          label-width="0"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="phoneForm.phone"
              placeholder="手机号"
              size="large"
              prefix-icon="el-icon-phone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-row :gutter="12">
              <el-col :span="16">
                <el-input
                  v-model="phoneForm.code"
                  placeholder="短信验证码"
                  size="large"
                  prefix-icon="el-icon-key"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-button
                  class="sms-btn"
                  :disabled="smsDisabled || !isPhoneValid"
                  @click="handleSendSms"
                  size="large"
                  plain
                >
                  {{ smsBtnText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handlePhoneLogin"
              :loading="loading"
              style="width: 100%"
              size="large"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { loginCheck, SendSmsCode, PhoneLogin } from "../api/login";
import { asyncRoutes } from "@/router/asyncRoutes";
import { filterRoutes } from "@/utils/permission";
import router from "@/router";

export default {
  name: "Login",
  data() {
    // 手机号格式校验
    const validatePhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    return {
      // ===== 登录方式 =====
      loginType: "account", // 'account' | 'phone'
      loading: false,

      // ===== 账号密码登录表单 =====
      loginForm: {
        username: "",
        password: "",
        vailCode: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        vailCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      codeUrl: "",

      // ===== 手机号登录表单 =====
      phoneForm: {
        phone: "",
        code: "",
      },
      phoneRules: {
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { len: 4, message: "验证码为4位数字", trigger: "blur" },
        ],
      },

      // ===== 短信验证码 =====
      smsCountdown: 0,
      smsTimer: null,
    };
  },
  computed: {
    smsDisabled() {
      return this.smsCountdown > 0;
    },
    smsBtnText() {
      return this.smsCountdown > 0 ? `${this.smsCountdown}s` : "获取验证码";
    },
    isPhoneValid() {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(this.phoneForm.phone);
    },
  },
  mounted() {
    this.refreshCode();
  },
  beforeDestroy() {
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
      this.smsTimer = null;
    }
  },
  methods: {
    // ============================================================
    // 切换登录方式
    // ============================================================
    switchTab(type) {
      if (this.loginType === type) return;
      this.loginType = type;
      if (type === "account") {
        this.$refs.loginForm?.resetFields();
        this.refreshCode();
      } else {
        this.$refs.phoneForm?.resetFields();
        this.phoneForm.code = "";
        if (this.smsTimer) {
          clearInterval(this.smsTimer);
          this.smsTimer = null;
        }
        this.smsCountdown = 0;
      }
    },

    // ============================================================
    // 刷新验证码
    // ============================================================
    refreshCode() {
      this.loginForm.vailCode = "";
      this.codeUrl = "";
      this.$nextTick(() => {
        this.codeUrl =
          systemConfig.serverUrl +
          "/Login/QueryLoginVerifyCode?t=" +
          Date.now();
      });
    },

    // ============================================================
    // 账号密码登录（原有逻辑保持不变）
    // ============================================================
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        loginCheck(this.loginForm)
          .then(async (res) => {
            if (res.data.isSuccess) {
              let data = res.data.data;
              sessionStorage.setItem("userInfo", JSON.stringify(data.user));
              sessionStorage.setItem("access_token", data.userToken);
              sessionStorage.setItem(
                "buttonIds",
                JSON.stringify(data.buttonIds)
              );
              this.$message.success(res.data.message);
              let permissions = data.menuIds;
              sessionStorage.setItem(
                "user_permissions",
                JSON.stringify(permissions)
              );

              const accessedRoutes = filterRoutes(asyncRoutes, permissions);
              accessedRoutes.forEach((route) => {
                router.addRoute("Dashboard", route);
              });

              const homeMenu = {
                path: "/home",
                name: "Home",
                meta: {
                  title: "首页",
                  icon: "el-icon-s-home",
                  permission: "home",
                },
              };
              const menuTree = [homeMenu, ...accessedRoutes];
              this.$store.commit("permission/SET_MENU_LIST", menuTree);
              this.$store.commit("setUserPermissions", data.buttonIds);
              await router.replace("/home");
            } else {
              this.$message.error(res.data.message);
              this.refreshCode();
            }
          })
          .catch((error) => {
            this.$message.error("登录失败，请检查网络");
            this.refreshCode();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ============================================================
    // 发送短信验证码
    // ============================================================
    handleSendSms() {
      this.$refs.phoneForm.validateField("phone", (errorMsg) => {
        if (errorMsg) return;
        SendSmsCode({ mobile: this.phoneForm.phone })
          .then((res) => {
            if (res.data.isSuccess) {
              this.$message.success(res.data.message || "验证码已发送");
              this.startCountdown();
            } else {
              this.$message.error(res.data.message || "发送失败");
            }
          })
          .catch(() => {
            this.$message.error("发送失败，请检查网络");
          });
      });
    },

    // 开始倒计时
    startCountdown() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
      this.smsCountdown = 60;
      this.smsTimer = setInterval(() => {
        this.smsCountdown--;
        if (this.smsCountdown <= 0) {
          clearInterval(this.smsTimer);
          this.smsTimer = null;
        }
      }, 1000);
    },

    // ============================================================
    // 手机号登录
    // ============================================================
    handlePhoneLogin() {
      this.$refs.phoneForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        PhoneLogin(this.phoneForm)
          .then(async (res) => {
            if (res.data.isSuccess) {
              let data = res.data.data;
              sessionStorage.setItem("userInfo", JSON.stringify(data.user));
              sessionStorage.setItem("access_token", data.userToken);
              sessionStorage.setItem(
                "buttonIds",
                JSON.stringify(data.buttonIds)
              );
              this.$message.success(res.data.message);
              let permissions = data.menuIds;
              sessionStorage.setItem(
                "user_permissions",
                JSON.stringify(permissions)
              );

              const accessedRoutes = filterRoutes(asyncRoutes, permissions);
              accessedRoutes.forEach((route) => {
                router.addRoute("Dashboard", route);
              });

              const homeMenu = {
                path: "/home",
                name: "Home",
                meta: {
                  title: "首页",
                  icon: "el-icon-s-home",
                  permission: "home",
                },
              };
              const menuTree = [homeMenu, ...accessedRoutes];
              this.$store.commit("permission/SET_MENU_LIST", menuTree);
              this.$store.commit("setUserPermissions", data.buttonIds);
              await router.replace("/home");
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((error) => {
            this.$message.error("登录失败，请检查网络");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  background-image: url('@/assets/img/login/bg3.jpg');
  background-size: 100% 100%;
}

.login-container {
  margin-right: 10px;
  text-align: center;
  position: absolute;
  right: 2%;
  width: 30%;
  top: 12%;
}

.platform-name {
  font-size: 28px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 20px;
}

.login-card {
  padding: 0 30px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #303133;
}

/* ========== Tab 切换 ========== */
.login-tabs {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 24px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0 10px;
  font-size: 15px;
  color: #909399;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.25s;
  user-select: none;
}

.tab-item:hover {
  color: #409eff;
}

.tab-item.active {
  color: #409eff;
  border-bottom-color: #409eff;
  font-weight: 500;
}

/* ========== 表单 ========== */
.el-form-item {
  margin-bottom: 20px;
}

.login-code {
  width: 100%;
  height: 38px;
  border: 1px #e8e8e8 solid;
}

/* ========== 短信验证码按钮 ========== */
.sms-btn {
  width: 100%;
  height: 40px;
  padding: 0;
  font-size: 13px;
  border-radius: 4px;
  background-color: #ecf5ff;
  border-color: #b3d8ff;
  color: #409eff;
}

.sms-btn:hover:not(.is-disabled) {
  background-color: #d9ecff;
  border-color: #79bbff;
}

.sms-btn.is-disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}

/* ========== 响应式微调 ========== */
@media screen and (max-width: 1200px) {
  .login-container {
    width: 40%;
  }
}

@media screen and (max-width: 768px) {
  .login-container {
    width: 80%;
    right: 10%;
  }
}

@media screen and (max-width: 480px) {
  .login-card {
    padding: 0 18px;
  }
  .platform-name {
    font-size: 22px;
  }
  .login-title {
    font-size: 20px;
  }
}
</style>